import React, { useCallback } from 'react';
import * as Styles from './ChooseWpMigrationStep.styles';
import { Button, IconArrow } from 'gatorcomponents';
import { GenericStep } from '@/components/FullWidthTemplate/GenericStep';

const ChooseWpMigrationStep = ({
  title,
  options = [
    {
      id: 1, title: 'title', description: ' description', cta: { label: 'cta', action: () => {} },
    },
    {
      id: 2, title: 'title', description: ' description', cta: { label: 'cta', action: () => {} },
    },
  ],
  buttonsProps,
}) => {
  const stepProps = useCallback(() => ({
    title,
    testId: 'choose-wp-migration-step',
    buttonsProps,
    contentWidthFlexible: true,
  }), [
    buttonsProps,
    title,
  ]);

  return (
    <Styles.Wrapper>
      <GenericStep {...stepProps()}>
        <Styles.OptionsWrapper>
          {options.map(option => (
            <Styles.ListItem key={option.id}>
              <Styles.OptionRow>
                <Styles.OptionTitle>
                  {option.title}
                </Styles.OptionTitle>
              </Styles.OptionRow>

              <Styles.OptionRow>
                <Styles.OptionDescription>
                  {option.description}
                </Styles.OptionDescription>
              </Styles.OptionRow>

              <Styles.OptionRow>
                <Button
                  variant="text"
                  onClick={option.cta.action}
                  iconRight={<IconArrow direction="right" />}
                  label={option.cta.label}
                  testId={`option-${option.id}-cta`}
                />
              </Styles.OptionRow>
            </Styles.ListItem>
          ))}
        </Styles.OptionsWrapper>
      </GenericStep>
    </Styles.Wrapper>
  );
};

export default ChooseWpMigrationStep;
